export default {
    searchText: 'ค้นหาชื่อพนักงาน, รหัสพนักงาน',
    search: 'ค้นหา',
    create: 'สร้างผู้ใช้งานใหม่',
    employeeId: 'รหัสพนักงาน',
    employeeName: 'ชื่อ',
    username: 'รหัสผู้ใช้',
    phoneNumber: 'เบอร์โทร',
    action: '',
    congratulation: 'ยินดีด้วย',
    userIsDeleted: 'ผู้ใช้งานถูกลบแล้ว',
    deleteUser: 'ลบผู้ใช้งาน',
    wantToDelete: 'คุณเเน่ใจหรือว่าต้องการลบผู้ใช้งาน'
}
